import { stringify } from 'qs'

const createSearchParams = (params: Parameters<typeof stringify>[0]) => {
  const stringParams = stringify(params, { indices: false })
  return new URLSearchParams(stringParams)
}

export default createSearchParams
